import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { MachinePath } from '../../Common';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { MachineFailureCategory } from '@/services/repository/machines';
import { Failure, LoadFailure, SaveFailure } from './Model';
import { BackButton } from '@/components/layout/NavBar';
import { Roles } from '@/services/repository/users';

const rolesAllowsFailureView = [Roles.CompanyAdmin, Roles.ServicemanRole, Roles.SuperAdmin];

export const AddFailurePage2 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const machineId = useParams().machineid
  const [translates, setTranslates] = useState<Translates>()
  const [machine, setMachine] = useState<Machine>()
  const [failure, setFailure] = useState<Failure>()
  const [failureDetailsForm, setFailureDetailsForm] = useState<string[]>()
  const [categories, setCategories] = useState<MachineFailureCategory[]>(services.machines.listFailureCategories())
  const [message, setMessage] = useState<string | undefined>(undefined)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  useEffect(() => {
    if (machineId === undefined) {
      return
    }
    const loaded = LoadFailure(machineId)
    setFailure(loaded)
    if (loaded?.category !== undefined) {
      setFailureDetailsForm(services.machines.failureCategoriesQuestions(loaded.category))
    }
  }, [machineId])

  if (translates === undefined || machine === undefined || translates === undefined || failure === undefined || machineId === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='add-failure' services={services} translates={translates} session={session} path={MachinePath({ session, translates, machine })}
    navbarLeft={<BackButton services={services} translates={translates} />}>

    <h2 className='page-title'>{translates.for(`failures.add.title`)}</h2>
    <div className='topcategory-box'>
      <img src={`/public/img/failures/${failure.category}.svg`} />
      <div className='title'>{translates.for(`failures.category.${failure.category}`)}</div>
    </div>

    {message === undefined ? (<>
      <div className='topcategory-btns'>
        <div className={`btn`} onClick={() => { navigate(`/communal/machine/${machineId}/failures/add/description`) }}>
          <div className='title'>{translates.for(`failures.add.nav.description`)}</div>
        </div>
        <div className={`btn`} onClick={() => { navigate(`/communal/machine/${machineId}/failures/add/gallery`) }}>
          <div className='title'>{translates.for(`failures.add.nav.gallery`)}</div>
        </div>
      </div>

      {failureDetailsForm !== undefined ? <div className='detailsform'>
        <h2 className='title'>{translates.for(`failures.form.title`)}</h2>
        {failureDetailsForm.map((row) => <div onClick={() => {
          setFailure((prev) => {
            if (!prev) return prev;
            const symptoms = new Set(prev.form.symptoms); // Create a new Set for immutability
            if (symptoms.has(row)) {
              symptoms.delete(row);
            } else {
              symptoms.add(row);
            }
            const updated = {
              ...prev,
              form: {
                symptoms
              }
            }
            SaveFailure(machineId, updated)
            return updated
          })
        }} className={`row ${failure.form.symptoms.has(row) ? 'selected' : ''}`}>{translates.for(`failures.form.${failure.category}.${row}`)}{failure.form.symptoms.has(row) ? <i className='svgfont-remove' /> : ''}</div>)}
      </div> : null}

      <div className='approve-btn' onClick={() => {
        services.session.fetchWithToken(`/api/public/machines/byid/${machineId}/failures`, {
          method: 'POST',
          body: JSON.stringify({
            category: failure.category,
            description: failure.description,
            galleryId: failure.galleryId,
            form: {
              symptoms: Array.from(failure.form.symptoms)
            },
            reportingUserId: session?.user.id
          }),
        }).then(async (r) => {
          if (r.status !== 200) {
            const err = await r.text()
            console.log(err)
            setError(err)
            return
          }
          if (session && rolesAllowsFailureView.includes(session?.user.role as Roles)) {
            return navigate(`/communal/machine/${machineId}/failures`)
          }
          setMessage(translates.for('page.machinefailures.thanks_for_report'))
        })
      }}>
        {translates.for(`failures.form.approve`)}
      </div>
    </>) : <div className='communal-dashboard-message-popup'>{message}</div>}

    { error ? <div className='critic-error-box'>{translates.for('errors.general_error')}</div> : '' }


  </MainPageLayout>
}
